'use client';

import { useEffect } from 'react';

export const ClientErrorHandler = () => {
  useEffect(() => {
    const handler = (e: ErrorEvent) => {
      if (e?.message?.includes('ChunkLoadError')) {
        console.warn('ChunkLoadError detected. Reloading...');
        window.location.reload();
      }
    };

    window.addEventListener('error', handler);
    return () => {
      window.removeEventListener('error', handler);
    };
  }, []);

  return null;
};
